import React from "react";
import { Link } from "react-router-dom";

function CallToAction() {
  return (
    <section
      className="py-5"
      style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h2 className="display-4 fw-bold text-white mb-4">
              Ready to Transform Your Business?
            </h2>
            <p className="lead text-white mb-5">
              Join hundreds of sportswear manufacturers who have streamlined
              their operations with OrderRun. Start your journey to
              efficiency today.
            </p>
            <div className="d-flex gap-3 justify-content-center flex-wrap">
              <Link
                to="#"
                className="btn btn-light btn-lg rounded-pill px-5 shadow-lg"
              >
                <i className="mdi mdi-rocket-launch me-2"></i>
                Start Free Trial
              </Link>
              <a
                href="#pricing"
                className="btn btn-outline-light text-white-hover btn-lg rounded-pill px-5"
              >
                <i className="mdi mdi-currency-usd me-2"></i>
                View Pricing
              </a>
            </div>
            <p className="text-white-50 mt-4 mb-0">
              <small>
                <i className="mdi mdi-check-circle me-2"></i>
                No credit card required
                <span className="mx-3">•</span>
                <i className="mdi mdi-check-circle me-2"></i>
                Free 30-day trial
                <span className="mx-3">•</span>
                <i className="mdi mdi-check-circle me-2"></i>
                Cancel anytime
              </small>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;
